export const privateProviderLicenseTypes = [
  { code: "PE", label: "Professional Engineer" },
  { code: "RA", label: "Registered Architect" },
  { code: "BCA", label: "Building Code Administrator" },
  { code: "BCI-Building", label: "Building Inspector" },
  { code: "BCI-Electrical", label: "Electrical Inspector" },
  { code: "BCI-Mechanical", label: "Mechanical Inspector" },
  { code: "BCI-Plumbing", label: "Plumbing Inspector" },
  { code: "BCPE-Building", label: "Plans Examiner - Building" },
  { code: "BCPE-Electrical", label: "Plans Examiner - Electrical" },
  { code: "BCPE-Mechanical", label: "Plans Examiner - Mechanica" },
  { code: "BCPE-Plumbing", label: "Plans Examiner - Plumbing" },
];
